import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './MorePage.module.css';

const MorePage = () => {
  return (
    <div className={styles.morePage}>
      <h2>More</h2>
      <ul className={styles.navList}>
        <li>
          <NavLink to="/app/shoppers">Shoppers</NavLink>
        </li>
        <li>
          <NavLink to="/app/wallet">Wallet</NavLink>
        </li>
        <li>
          <NavLink to="/app/data-insight">Data Insight</NavLink>
        </li>
        <li>
          <NavLink to="/app/administration">Administration</NavLink>
        </li>
        <li>
          <NavLink to="/app/settings">Settings</NavLink>
        </li>
        <li>
          <NavLink to="/app/profile">Profile</NavLink>
        </li>
      </ul>
    </div>
  );
};

export default MorePage; 